import { Box, Theme, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useAuth } from 'components/AuthProvider'
import DefaultLayout from 'components/layout/DefaultLayout'
import LoadingWrapper from 'components/layout/LoadingWrapper'
import { BlinkPayTransferStatusPath } from 'components/Routes/Routes'
import { useMutateVerifyBlinkpayTransaction } from 'hooks/useTransfers'
import { useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

const useStyles = makeStyles()((theme: Theme) => ({
  header: {
    textAlign: 'center',
    color: theme.palette.primary.main,
    fontSize: '3rem',
    margin: theme.spacing(4, 0)
  },
  loading: {
    margin: 'auto',
    color: theme.palette.primary.main
  }
}))

export default function BlinkPayTransferLoading(): JSX.Element {
  const { classes } = useStyles()
  const { setToast } = useAuth()
  const navigate = useNavigate()
  const { search } = useLocation()
  const quickPaymentId = new URLSearchParams(search).get('cid')
  const hasRequested = useRef(false)

  const { mutate: verifyBlinkpayTransaction, isLoading } =
    useMutateVerifyBlinkpayTransaction()

  useEffect(() => {
    if (!quickPaymentId) {
      setToast({
        message: 'Missing payment session. Please start the payment again.',
        open: true,
        duration: 3000,
        type: 'error'
      })
      return
    }
    if (hasRequested.current) return
    hasRequested.current = true

    verifyBlinkpayTransaction(quickPaymentId, {
      onSuccess: data => {
        navigate(BlinkPayTransferStatusPath(), {
          state: {
            status: data.transactionStatus,
            success: data.success,
            message: data.message
          }
        })
      },
      onError: (error: unknown) => {
        const message =
          error instanceof Error ? error.message : 'An error occurred'
        setToast({
          message,
          open: true,
          duration: 3000,
          type: 'error'
        })
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickPaymentId])

  return (
    <DefaultLayout
      wrapperContainer={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }}
    >
      <Box>
        <Typography variant='h1' component='h1' className={classes.header}>
          BLINKPAY PAYMENT LOADING
        </Typography>
        <LoadingWrapper className={classes.loading} loading={isLoading}>
          <div />
        </LoadingWrapper>
      </Box>
    </DefaultLayout>
  )
}
